import { render, staticRenderFns } from "./PageConfiguration.vue?vue&type=template&id=2ffbe418&"
import script from "./PageConfiguration.vue?vue&type=script&lang=js&"
export * from "./PageConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PageConfiguration.vue?vue&type=style&index=0&id=2ffbe418&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ffbe418')) {
      api.createRecord('2ffbe418', component.options)
    } else {
      api.reload('2ffbe418', component.options)
    }
    module.hot.accept("./PageConfiguration.vue?vue&type=template&id=2ffbe418&", function () {
      api.rerender('2ffbe418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/attribute/PageConfiguration.vue"
export default component.exports